class TLGModal {
    constructor(options) {
        this.title = options.title || '';
        this.description = options.description;
        this.data = options.data || {};
        this.type = options.type || '';
        this.template = options.template || 'basic';
		this.render();
    }

    render() {
        const modalContainer = document.createElement('div');
        modalContainer.classList.add('lg-popup__modal');
        modalContainer.innerHTML = this.loadTemplate(this.template);
        document.body.appendChild(modalContainer);

        const dialog = modalContainer.querySelector('dialog');

        dialog.showModal();

        // Add event listener to close button
        const closeBtn = modalContainer.querySelector('.close-btn');

        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                document.dispatchEvent(new CustomEvent('modalClosed'), { detail: {} });
                this.close(modalContainer);
            });
        }
    }

    // Method to close the modal
    close(modalContainer) {
        const dialog = modalContainer.querySelector('dialog');
		if (dialog) {
			dialog.close();
			document.body.removeChild(modalContainer);
		}
    }

    // Method to get template based on template name
    loadTemplate(templateName) {
        const templates = {
            iframe:
            `
            <dialog class="vg-modal vg-modal__iframe">
                <button class="close-btn"><span class="icon icon--close"></span></button>
                <div class="vg-modal__content vg-modal__iframe--content">
					${ ( '' != this.title) ? '<h2 class="vg-modal__title has-h-3-font-size">'+this.title+'</h2>' : '' }
                    <iframe class="iframe-content" src="${this.data.url}"></iframe>
                </div>
            </dialog>
            `,
        };
        return templates[templateName];
    }
}